import {
    IS_LOADING_WINERIES,
    LIST_OF_WINERIES, CREATE_WINERY,
    IS_LOADING_DELETE_WINERIES,
    DELETE_WINERY, IS_LOADING_ONLY_WINERY, GET_ONLY_ONE_WINERY,EDIT_WINERY
} from "../actions/types"

const initialState = {
    isLoadingWineriesList: false,
    wineriesList: [],
    winery:{},
    isLoadingCreateWinery: false,
    isLoadingDeleteWinery: false,
    isLoadingGetOnlyWinery: false,
    isLoadingUpdateWinery: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case IS_LOADING_WINERIES:
            return { ...state, isLoadingWineriesList: true }
        case LIST_OF_WINERIES:
            return { ...state, wineriesList: action.payload, isLoadingWineriesList: false }
        case CREATE_WINERY:
            return { ...state, isLoadingWineriesList: false }
        case IS_LOADING_DELETE_WINERIES:
            return { ...state, isLoadingDeleteWinery: true }
        case DELETE_WINERY:
            const newWineryList = state.wineriesList.filter((item) => item['_id'] !== action.payload.id)
            return { ...state, isLoadingDeleteWinery: false, wineriesList: newWineryList }
        case IS_LOADING_ONLY_WINERY:
            return { ...state, isLoadingGetOnlyWinery: true }
        case GET_ONLY_ONE_WINERY:
            return { ...state, winery: action.payload.data }
        case EDIT_WINERY:
            return { ...state, isLoadingUpdateWinery: false, wineriesAdmin: action.payload.data }
        default: return state;
    }
}